import { render } from "./FeaturedCreators.vue?vue&type=template&id=0d089c05&scoped=true"
import script from "./FeaturedCreators.vue?vue&type=script&lang=ts"
export * from "./FeaturedCreators.vue?vue&type=script&lang=ts"

import "./FeaturedCreators.vue?vue&type=style&index=0&id=0d089c05&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-0d089c05"

export default script